import ProductImage from "../ProductImage";
import LazyProductHero from "../LazyProductHero";
import ProductTileBanners from "../ProductTileBanners";
import styles from "./index.css";

const ProductHero = props => (
  <LazyProductHero
    className={styles.productHero}
    render={lazyProps => <ProductImage {...{ ...props, ...lazyProps }} />}
  >
    <ProductTileBanners {...props} />
  </LazyProductHero>
);

export default ProductHero;
